<template>
  <div class="musicList container">
    <ScrollBar ref='scrollbar' @refresh="refresh" @loadMore="loadMore">
      <SearchNav @getId="getId" @search="search" @visible='visible=true' :showTag="showTag"></SearchNav>
      <div class='list_ontent' v-if='musiclist.length>0'>
        <div class='music' v-for="(item,idx) in musiclist" :key="idx" @click.prevent="handleMusic(item)">
          <div class="cover">
            <el-image fit="cover" class="cover-main" :src="item.logo" />
            <img class="cover-fixed" :src="require('@/assets/svg/record.svg')" />
          </div>
          <div class='music_aside'>
            <span class='music-name'>{{item.name}}</span>
            <span class='music_tag'>{{item.labelTag}}</span>
          </div>
          <div class='music_opera'>
            <img :src="require(`@/assets/svg/${item.is_collect? 'collected' : 'collect'}.svg`)" @click.stop="handleMusicCollect(item)" />
            <!--<img :src="require('@/assets/svg/share-gray.svg')" @click="handleShare('', item.object_id, 2, item.name)" />-->
            <!--<img :src="require('@/assets/svg/download-gray.svg')" @click.stop="handleDownload(item, 'single')" />-->
            <!--<img :src="require('@/assets/svg/download-gray.svg')" @click.stop="downloadFile(item)" />-->
            <img :src="require('@/assets/svg/download-gray.svg')" @click.stop="downloadFile(item)" />
          </div>
        </div>
      </div>
      <div class='nodata' v-else>
        <NoData></NoData>
      </div>
    </ScrollBar>
    <PlayBar v-if='Info' :musicInfo="Info" ref='audioRef'></PlayBar>
    <!--侧边栏（标签筛选）-->
    <DrawerTemp :visible="visible" :data="taglist" type="2"></DrawerTemp>
    <!--下载提升弹框-->
    <dialogBox :packageObj='packageObj' :visible='visibleDialog' v-if='visibleDialog'></dialogBox>
  </div>
</template>
<script>
import NoData from "./components/noData"
import dialogBox from "./components/DialigBox"
import ScrollBar from './components/ScrollBar'
import PlayBar from './components/PlayBar'
import SearchNav from './components/SearchNav'
import DrawerTemp from './components/DrawerTemp'
import Buttons from '@/layout/mixins/Buttons'
import Common from './mixins/Common';
import { getLabels } from '@/api/mobile'
import { fetchMusicList } from "@/api/music"
// import { EventBus } from '@/utils/bus'
// import { getToken } from '@/utils/author'

export default{
  components:{
    SearchNav,
    DrawerTemp,
    ScrollBar,
    PlayBar,
    dialogBox,
    NoData
  },
  mixins: [Buttons,Common],
  data(){
    return{
      showTag: true,
      Info: null,
      cover_url: require("@/assets/image/mobile/music_cover.jpg"),
      musiclist: [],
      visible: false,
      taglist: [],
      keyword_name: '',
      order: '',
      activeTag: [],
      page: 0,
      pageSize: 20
    }
  },
  watch:{
    musiclist:{
      handler(v){
        if(v.length>0){
          this.showTag = true;
        }else{
          this.showTag = false;
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.getTaglist();
    // EventBus.$on('getDownInfo', (data)=>{
    //   this.downloadItem(data)
    // });
  },
  methods:{
    handleMusic(item){
      this.Info = item;
      // this.$store.dispatch("mobile/updateCurrentMusic", {
      //   name: item.name,
      //   music_src: item.watermark_file,
      //   music_id: item.music_id,
      //   duration: item.duration,
      //   logo: item.logo
      // });
      // this.$store.dispatch("mobile/play");
    },
    //获取标签列表
    async getTaglist(){
      const {data, code ,msg} = await getLabels({
        type: 2
      });
      if(code !== 0){
        this.$message.error(msg);
        return;
      }
      this.taglist = data || [];
    },
    // 获取音乐列表
    async getList(){
      if(window.sessionStorage.getItem('musicTag')){
        let arr = window.sessionStorage.getItem('musicTag');
        this.activeTag =  JSON.parse(arr) || [];
      }
      const {data, code ,msg} = await fetchMusicList({
        page: this.page,
        limit: this.pageSize,
        label_id: this.activeTag.join(","),
        order: this.order,
        keyword_name: this.keyword_name
    });
      if(code !== 0){
        this.$message.error(msg);
        return;
      }
      data && data.list.forEach(item=>{
        if(item.label){
          item.labelTag = item.label.map(o=>{
            return o.name;
          }).join("，")
        }
      });
      this.musiclist = data.list || [];
    },
    // 收藏
    async handleMusicCollect(item) {
      item.is_collect = item.is_collect === 0 ? 1 : 0;
      await this.handleCollect(item.object_id, 2, {
        ...item,
        type: 2,
        labels: item.label
      }, false)
    },
    getId(e){
      this.order = e.value;
      this.getList();
    },
    search(val){
      this.keyword_name = val;
      this.page = 0;
      this.pageSize = 20;
      this.getList();
    },
    // 下拉刷新
    refresh(){
      this.page = 1;
      this.pageSize = 20;
      this.getList();
      this.$refs.scrollbar.$refs.scroller.finishPullToRefresh();
    },
    // 上拉加载
    loadMore(){
      if(this.page === 1 && this.musiclist.length < 1){
        this.$refs.scrollbar.$refs.scroller.finishInfinite(true);
        return;
      }
      this.page += 1;
      if(window.sessionStorage.getItem('musicTag')){
        let arr = window.sessionStorage.getItem('musicTag');
        this.activeTag =  JSON.parse(arr) || [];
      }
      fetchMusicList({
        page: this.page,
        limit: this.pageSize,
        label_id: this.activeTag.join(","),
        order: this.order,
        keyword_name: this.keyword_name
      }).then(res=>{
        if(res.code !== 0){
          this.$message.error(res.msg);
          return;
        }
        res.data && res.data.list.forEach(item=>{
          if(item.label){
            item.labelTag = item.label.map(o=>{
              return o.name;
            }).join("，")
          }
        });
        if(res.data.list.length > 0){
          this.musiclist = this.musiclist.concat(res.data.list) || [];
          this.$refs.scrollbar.$refs.scroller.finishInfinite(false);
        }else{
          this.$refs.scrollbar.$refs.scroller.finishInfinite(true);
        }
      });
    },
    // downloadItem(item){
    //   fetch(decodeURIComponent(item.down_url)).then(res=>{
    //     let a = document.createElement('a');
    //     a.href = res.url;
    //     a.download = "download";
    //     a.click();
    //     window.URL.revokeObjectURL(res.url);
    //   });
    // },
    // async downloadFile(){
    //   let formdata = new FormData();
    //   formdata.append("openrecord_id","840131c309e43097001");
    //   formdata.append("object_id","7300e99021efb000001");
    //   formdata.append("object_type","2");
    //   const response = await fetch(`${process.env.VUE_APP_BASE_URL}/fontend/certificate/download`,{
    //     method: 'POST',
    //     headers: {
    //       'token': getToken()
    //     },
    //     body: formdata
    //   });
    //   let result = await response.json();
    //   if(result.code !== 0){
    //     this.$message.error(result.msg);
    //     return;
    //   }
    //   let a = document.createElement('a');
    //   a.href = result.data.down_url;
    //   a.style.display = 'none';
    //   a.download = "download"; // decodeURIComponent(filename)
    //   a.click();
    //   window.URL.revokeObjectURL(result.data.down_url);
    // }
  },
  beforeDestroy() {
    // this.$store.dispatch("mobile/updateCurrentMusic", {
    //   name: "",
    //   music_src: "",
    //   music_id: "",
    //   duration: "",
    //   logo: ""
    // });
    // this.$store.dispatch("mobile/pause");
    this.Info = null;
    window.sessionStorage.removeItem("musicTag");
    if(this.$refs.audioRef){
      if(this.$refs.audioRef.playRef){
        this.$refs.audioRef.playRef.pause();
      }
      this.$refs.audioRef.playRef = null;
      this.$refs.audioRef.playing = false;
      this.$refs.audioRef.currentTime = 0;
    }
  },
}
</script>
<style lang="scss" scoped>
.musicList{
  width: 100%;
  height: 100%;
  .list_ontent{
    width: 100%;
    margin-top: 16px;
    padding: 0 22px 0 20px;
    box-sizing: border-box;
    .music{
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      margin-top: 16px;
      .cover{
        flex: 0 0 60px;
        height: 100%;
        position: relative;
        .cover-main{
          width: 48px;
          height: 48px;
          position: absolute;
          z-index: 2;
          border-radius: 6px;
          object-fit: cover;
        }
        .cover-fixed{
          display: inline-block;
          width: 40px;
          height: 40px;
          position: absolute;
          z-index: 1;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }
      .music_aside{
        flex: 1;
        padding: 3px 0 3px 24px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        overflow: hidden;
        .music-name{
          display: inline-block;
          width: 100%;
          height: 21px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51,51,51,0.75);
          line-height: 21px;
          overflow: hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
        }
        .music_tag{
          display: inline-block;
          width: 100%;
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51,51,51,0.25);
          line-height: 17px;
          margin-top: 4px;
          overflow: hidden;
          white-space:nowrap;
          text-overflow:ellipsis;
        }
      }
      .music_opera{
        margin-left: 12px;
        height: 100%;
        display: flex;
        align-items: center;
        img{
          display: inline-block;
          margin: 0 8px;
          &:first-child,&:last-child{
            height: 20px;
          }
          &:nth-child(2){
            height: 20px;
          }
        }
      }
    }
  }
}
.nodata{
  flex: 1;
}
/deep/{
  .swiper-container{
    .swiper-wrapper{
      height: auto !important;
    }
  }
}
</style>
